export default {
	attributes: {
		restrictContentWidth: false,
		fullHeight: false,
		design: 'plain',
		shadow: 5,
		columnBackgroundColor: '#dbdbdb',
		columnBackgroundCustomSizeUnit: '%',
		columnTabletBackgroundCustomSizeUnit: '%',
		columnMobileBackgroundCustomSizeUnit: '%',
		title: 'Header Title',
		showTitle: true,
		titleColor: '#ffffff',
		titleLineHeightUnit: 'em',
		titleTabletLineHeightUnit: 'em',
		titleMobileLineHeightUnit: 'em',
		subtitle: 'Description for this block. Use this space for describing your block. Any text will do.',
		showSubtitle: true,
		subtitleLineHeightUnit: 'em',
		subtitleTabletLineHeightUnit: 'em',
		subtitleMobileLineHeightUnit: 'em',
		subtitleColor: '#ffffff',
		showButton: true,
		buttonLineHeightUnit: 'em',
		buttonTabletLineHeightUnit: 'em',
		buttonMobileLineHeightUnit: 'em',
		buttonText: 'Button text',
		buttonNewTab: false,
		showButton2: false,
		button2LineHeightUnit: 'em',
		button2TabletLineHeightUnit: 'em',
		button2MobileLineHeightUnit: 'em',
		button2NewTab: false,
		invert: false,
		uniqueClass: 'ugb-e95d5ec',
		hideDesktop: false,
		hideTablet: false,
		hideMobile: false,
		showBlockBackground: true,
		blockInnerWidth: 'wide',
		align: 'full',
		blockBackgroundBackgroundColor: '#000000',
		blockBackgroundBackgroundMediaUrl: 'https://source.unsplash.com/800x500/?nature,plant,trees',
		blockBackgroundBackgroundTintStrength: 3,
		blockBackgroundBackgroundCustomSizeUnit: '%',
		blockBackgroundTabletBackgroundCustomSizeUnit: '%',
		blockBackgroundMobileBackgroundCustomSizeUnit: '%',
		topSeparatorDesign: 'wave-1',
		bottomSeparatorDesign: 'wave-1',
		topSeparatorShadow: true,
		bottomSeparatorShadow: true,
	},
}
